import { useRef } from "react";
import { useLogger } from "amazon-chime-sdk-component-library-react";
import {
  VideoPriorityBasedPolicy,
  VideoPriorityBasedPolicyConfig,
  ServerSideNetworkAdaption,
} from "amazon-chime-sdk-js";
import { useChimeObserver } from "./useChimeObserver";
import { useActiveSpeakerDownlinkSync } from "./useActiveSpeakerDownlinkSync";
import { useLocalVideoSync } from "./useLocalVideoSync";

/**
 * Manages the Chime SDK video downlink policy: creates the priority-based
 * policy, mounts the unified observer, and coordinates downlink sync hooks.
 */
function createPolicyConfig(): VideoPriorityBasedPolicyConfig {
  const config = new VideoPriorityBasedPolicyConfig();
  config.serverSideNetworkAdaption =
    ServerSideNetworkAdaption.BandwidthProbingAndRemoteVideoQualityAdaption;
  return config;
}

export function useVideoDownlinkPolicy() {
  const logger = useLogger();
  const policyRef = useRef<VideoPriorityBasedPolicy>(
    new VideoPriorityBasedPolicy(logger, createPolicyConfig())
  );

  const state = useChimeObserver(policyRef);
  useActiveSpeakerDownlinkSync(state);
  useLocalVideoSync(state);
}
